import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Backdrop,
  Grid,
  IconButton,
  Typography
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import dayjs from "dayjs";
import _ from "lodash";
import moment from "moment";
import React, { Fragment, memo, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../../components/hooks/snackBar/reducers";
import CustomTable from "../../customTable";
import { useStyle } from "../../style";
import DayReports from "./dayReports";
import MonthReports from "./monthReports";
import ProductReport from "./productReport";
import YearReports from "./yearReports";
const OutletSalesLedger = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const outletId = localStorage.getItem("outlet_id")
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const[allData , setAllData] = useState([])
  const [cust, setCust] = useState(null);
  const [open, setOpen] = useState(false);
  const [monthData, setMonthData] = useState([]); //month api
  const [dateData, setDateData] = useState([]); //date api
  const [productData, setProductData] = useState([])
  const [activeStep, setActiveStep] = useState("0");
  const [outletIdRow , setOutletIdRow] = useState('')
  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().subtract(1 , "years").format("YYYY"),
    toDate: moment().format("YYYY"),
  });
  // const onEdit = (e) => {
  //   console.log(e.row);
  //   getMonthData(e.row.month, e.row.year);
  //   setOpen(true);
  // };
  const onEditAll =(e) => {
    const fromYear = dateLimit.fromDate
    const ToYear = dateLimit.toDate
    console.log(e.row.outId)
    const outID = e.row.outId
    setOutletIdRow(e.row.outId)
    handleGetData(fromYear , ToYear ,outID)
    setOpen(true);
  }
  // const onEditDate = (e) => {
  //     console.log(e.row)
  //     getDateData(e.row.date)
  //     setOpen(true)
  // }
  
  function getDateData(date) {
    console.log(date);
    axios
    .get(`/v1/reports/sales/day/outlet_sales/${rowsPerPage}/${page + 1}/${date}/${outletIdRow}`)
      // .get(`/v1/reports/sales/day/outlet_sales/${rowsPerPage}/${page + 1}/${date}/${outletId}`)
      .then((res) => {
        console.log(res);
        setDateData(res.data);
    // setPageCount(res.data.details.length)

      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setSnackbar(true, "error", err.response.data.error)
        );
      });
  }
  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "fullname",
      headerName: "Outlet Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "code",
      headerName: "Code",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "bills",
      headerName: "Bill",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "total",
      headerName: "Total",
      flex: 1,
      headerAlign: "center",
      align: "right",
      sortable: false,
      renderCell: (params) => (
        <strong>{params.value}</strong>
      ),
    },
    {
      field: "view",
      headerName: "View",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableExport: true ,
      renderCell: (params) => {
        return (
          <IconButton size="small" onClick={() => onEditAll(params)}>
            <VisibilityIcon />
          </IconButton>
        );
      },
    },
  ];

  const rows = _.map(allData.details, (val, idx) => ({
    id: idx,
    sno: idx + 1,
    fullname: val.fullname,
    code: val.code,
    bills: val.bills,
    total:parseFloat(val.total).toFixed(0),
    outId:val.outlet_id
  }));

  const props = {
    columns: columns,
    rows: rows,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };
  
  function handleChange(e, name) {
    setDateLimit((prev) => ({ ...prev, [name]: dayjs(e).format("YYYY") }));
  }

  function handleGetData(fromYear ,ToYear,outID ) {
    axios
      .get(
        `/v1/reports/sales/year/outlet_sales/${fromYear}/${ToYear}/${outID}`
      )
      .then((res) => {
        setData(res.data);
        // setPageCount(res.data.details.length)
        console.log(res.data.details.length);
      })
      .catch((err) => {
        dispatch(
          setSnackbar(true, "error", err.response.data.error)
        );
      });
  }
  function allOutlets(){
    axios.get(`/v1/reports/alloutlets/sales/${dateLimit.fromDate}/${dateLimit.toDate}`)
    .then((res) => {
      console.log(res.data)
      setAllData(res.data)
      setPageCount(res.data.details.length)
    })
    .catch((err) => {
      console.log(err)
      dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    })
  }
  useEffect(() => {
    if (dateLimit.fromDate !== null && dateLimit.toDate !== null) {
      // handleGetData();
      allOutlets()
    }
  }, [rowsPerPage, page, dateLimit]);
  console.log(productData);

  // useEffect(() => {
  //   allOutlets()
  // },[])
  return (
    <Fragment>
      <Helmet><title>Sales Ledger</title></Helmet>
      <Typography variant="h6">Sales Ledger</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["year"]}
              openTo="year"
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              slotProps={{
                textField: {
                  size: "small",
                  label: "From",
                  style: { width: "100%" },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["year"]}
              openTo="year"
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              slotProps={{
                textField: {
                  size: "small",
                  label: "To",
                  style: { width: "100%" },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props} />
      <Backdrop open={open} sx={{ zIndex: 1100 }}>
        <Grid
          sx={{
            width: "80%",
            maxHeight: "80vh",
            backgroundColor: "#fff",
            borderRadius: "5px",
          }}
        >
          {activeStep === "0" ? 
          <YearReports 
          setOpen={setOpen}
          data={data}
          setActiveStep={setActiveStep}
          monthData={monthData}
          setMonthData={setMonthData}
          outletIdRow={outletIdRow}
          /> 
          :
          activeStep === "1" ? (
            <MonthReports
              setOpen={setOpen}
              monthData={monthData}
              getDateData={getDateData}
              setActiveStep={setActiveStep}
              outletIdRow={outletIdRow}

            />
          ) : activeStep === "2" ? (
            <DayReports
              dateData={dateData}
              setOpen={setOpen}
              setActiveStep={setActiveStep}
              setProductData={setProductData}
              outletIdRow={outletIdRow}

            />
          ) : activeStep === "3" ? (
            <ProductReport setActiveStep={setActiveStep}
            outletIdRow={outletIdRow}
          setOpen={setOpen} dateData={productData} />
          ) : null}
        </Grid>
      </Backdrop>
    </Fragment>
  );
};

export default memo(OutletSalesLedger);
